/*
  This component is used temporary to set styles for the old navigation bar, that was initially done with bootstrap
*/
import './styles.scss';
import preventStickyBar from '../navbar-2021/preventStickyBar';
import 'bootstrap/js/dist/offcanvas';

document.addEventListener('DOMContentLoaded', () => preventStickyBar);
